import chat from './chat';
import groupTasks from './group-tasks';
import mentorshipGroups from './mentorship-groups';

export default {
  ...chat,
  ...mentorshipGroups,
  ...groupTasks,
};
